import { Injectable } from '@angular/core';
import { ApiClient } from '../http/api-client';

@Injectable({
  providedIn: 'root',
})
export class BanksService {
  constructor(private restangular: ApiClient) {}

  adjustDwollaBalance(userId: string, amount: number, adjustLedger: boolean): Promise<any> {
    return this.restangular.one('dwolla').one('user', userId).one('adjustbalance').customPOST({ amount, adjustLedger }).toPromise();
  }
}
